module.exports = __webpack_public_path__ + "assets/img/onu-logo.e209a6ab.png";